/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal, drupalSettings) {

  "use strict";
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };


  /**
   * Author https://codepen.io/gapcode/pen/vEJNZN
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  var detectIE = function() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
         // Edge (IE 12+) => return version number
         return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
  }

  /**
   * Extend jQuery events to inform megamenu about needed actions
   */
  if( typeof Drupal.extendedJqueryEvents === 'undefined' ){

    var orig_addClass    = $.fn.addClass,
        orig_removeClass = $.fn.removeClass;

    $.fn.extend({
      addClass: function() {
        var result = orig_addClass.apply(this, arguments);
        this.trigger({type:"style-change", orig:'addClass', arg:arguments});
        return result;
      },
      removeClass: function() {
        var result = orig_removeClass.apply(this, arguments);
        this.trigger({type:"style-change", orig:'removeClass', arg:arguments, el: this});
        return result;
      },
    });

    $.fn.findThing = function(selector,subSelector){
      if( this.is(selector) ){
        return this.find(subSelector);
      }
      return this.find(selector+' '+subSelector);
    }

    Drupal.extendedJqueryEvents = true;
  }

  var windowWidth  = function(){return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);},
      windowHeight = function(){return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);};



  // Megamenu
  Drupal.treston = {
    menuActions: {
      init: false,
      start: function(context) {
        var that = Drupal.treston.menuActions,
            findString = 'block-superfishmain';

        if( typeof context.classList !== 'undefined' && !context.classList.contains(findString) ){
          context = context.querySelector( '.'+findString )
        }
        else {
          context = context.querySelector( '.'+findString )
        }

        if( context === null ){
          return;
        }

        // Start to find all needed elements
        context.querySelectorAll('li.sf-depth-1.menuparent:not(.sf-multicolumn-wrapper)').forEach( function( item, i ) {
          var $firstUl = item.querySelector('ul');
          if( typeof $($firstUl).data('styleChange') !== 'undefined' ){
            return;
          }

          // if we have old elements remove them and return new promo
          var $promo = $( that.resetPromoElements( item ) );

          // this will be provide reseting promo element and fixes navigation floating issues
          $( $firstUl ).on('style-change',function(a,b,c){
            if( a.arg[0] == 'sf-hidden' ){
              that.resetPromo(this);
              if( a.orig == 'removeClass' ){
                setTimeout( that.superfishElementCorrection, 33, this ); // 30fps
              }else if( a.orig == 'addClass' ){
                this.style.left = '0px';
                this.style.right = '';
              }
            }
            $( item.querySelectorAll('ul') ).data('styleChange','set');
          });

          var $link = $( item.children[0] );

          $promo.data('promo',{
            src: $link.data('product-image'),
            txt: $link.data('intro-text')
          });

          that.resetPromo(item);

          var tmptxtEl = $promo.find('.promo-text');
          var tmpimgEl = $promo.find('img');

          // Add handlers to elements so we can render promo
          item.querySelectorAll('li > a').forEach( function ( item ) {
            item = $(item);
            item.data('promo',{
              el: $promo,
              txtEl: tmptxtEl,
              imgEl: tmpimgEl,
              img: typeof item.data('product-image') == 'undefined' ? '':item.data('product-image'),
              txt: typeof item.data('intro-text') == 'undefined' ? '':item.data('intro-text'),
              link: item.data('link'),
              linkTarget: item.attr('target'),
              linkLabel: item.data('link-label'),
            }).off('mouseenter mouseleave').hover(function(e){
              if( e.target.tagName == 'A' ){
                that.renderPromo( item.data('promo') );
              }
            });
          });

        });
      },
      // self explaining i think
      superfishElementCorrection: function( e ){
        var rect = e.getBoundingClientRect();
        var rightSide = (rect.x + rect.width);
        var linkRect = e.parentElement.getBoundingClientRect();
        var halfOfSpace = (rect.width-windowWidth()) / 2;

        if( e.style.right != '0px' && rightSide ){

          var rightSide = (rect.x + rect.width);
          var leftPos = ( windowWidth() - rightSide ) + halfOfSpace;
          var rightCorrection = (rect.x+rect.width+(leftPos))-(linkRect.x+linkRect.width);
          e.style.left = (leftPos-(rightCorrection<0?rightCorrection:(leftPos>0?leftPos:0)))+'px';
        }else{
          var rightPos = rect.x+halfOfSpace;
          e.style.right = (rightPos>0?0:rightPos)+'px';
        }
      },
      // Init functions
      resetPromoElements: function ( where ){
        var isThere = where.querySelectorAll('div.promo');
        if( isThere !== null ){
          isThere.forEach( function(item) {
            item.parentNode.removeChild(item);
          });
        }
        this._appendPromoElement( where );
        return where.querySelector('div.promo');
      },
      _appendPromoElement: function(where){
        $( where.querySelector('ul') ).append(
          '<div class="promo">'+
          '<img style="transition:none;filter:blur(0);-ms-filter:"progid:DXImageTransform.Microsoft.MotionBlur(strength=50)";-webkit-filter: blur(10px);" src="" width="480" height="305"/>'+
          '<div class="promo-text"></div>'+
          '</div>'
        );
      },
      //Function To render items to promo element to menu
      renderPromo: function(o){
        var html;
        // image Selection
        if( o.img != '' ){
          if( o.imgEl.attr('src') != o.img ){
            o.imgEl.attr('data-src', o.img ).removeClass('lazyloaded').addClass('lazyload');
          }
        }else{
          o.imgEl.attr( 'src', o.el.data('promo').src)
        }

        // Build text or link + text
        html = '<span>'+Drupal.t( o.txt != '' ? o.txt : o.el.data('promo').txt )+'</span>';

        if( typeof o.link == 'undefined' ){
          o.el.removeClass('link');
        }else{
          o.el.addClass('link');
          html += '<a href="'+o.link+'"'+(typeof o.linkTarget!='undefined'?' target="'+o.linkTarget+'"':'')+'>'+Drupal.t(o.linkLabel)+'</a>'
        }
        if( html === '<span></span>' ){html = '';}
        if( o.txtEl.html() != html && typeof html != 'undefined' ){
          o.txtEl.html(html);
        }
      },
      // set Promo to parent item so it looks fabulous on opening
      resetPromo: function(a){
        var $promo = $( a.querySelector('div.promo') );
        $promo.removeClass('link')
          .find('img').attr('src','/sites/default/themes/treston/images/1x1.gif').attr( 'data-src', $promo.data('promo').src ).removeClass('lazyloaded').addClass('lazyload')
          .siblings('.promo-text').html( $promo.data('promo').txt );
      }
    }
  }



  Drupal.behaviors.treston = {
    firstShot: false,

    attach: function(context, settings) {

      // Webshop products reactivity

      $('.paragraph--type--webshop-product .content-opener').once('initialize-product-content-opener').on('click', function(e){
        var element = $(e.target);
        if(element.hasClass("closed")) {
          $('.paragraph--type--webshop-product .content-opener').removeClass("closed");
          $('.paragraph--type--webshop-product .field--name-field-includes-list').addClass('open');
          $('.paragraph--type--webshop-product .field--name-field-includes-list').css('max-height', "400px");
          setTimeout(function(){
            var includes = $('.paragraph--type--webshop-product .field--name-field-includes-list');
            var maxHeight = 0;
            includes.each(function(){
              if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
              }
            });
            includes.each(function(){
              $(this).css("max-height", maxHeight + "px");
              $(this).css("overflow", "visible");
            });
          }, 500)
        }
        else {
          $('.paragraph--type--webshop-product .field--name-field-includes-list').css('overflow', "hidden");
          $('.paragraph--type--webshop-product .content-opener').addClass("closed");
          $('.paragraph--type--webshop-product .field--name-field-includes-list').removeClass('open');
          $('.paragraph--type--webshop-product .field--name-field-includes-list').css('max-height', "0px");
          $('.paragraph--type--webshop-product .tooltip-container').removeClass('open');

        }
      });


      $('.paragraph--type--webshop-product .tooltip-container').once('initialize-tooltip-closer').on('click', function(e){
        $('.paragraph--type--webshop-product .tooltip-container').removeClass('open');
      });

      $('.paragraph--type--webshop-product .tooltip-opener').once('initialize-tooltip-opener').on('click', function(e){
        $('.paragraph--type--webshop-product .tooltip-container').removeClass('open');
        var element = $(e.target);
        element.parent().parent().siblings('.tooltip-container').addClass('open');
      });

      $('.paragraph--type--webshop-product .webshop-product-cta-nolink').once('set-webshop-product').on('click', function(e){
        var element = $(e.target);
        var productName = element.attr("data-product-name");
        var pageURL = window.location.href;
        var formModule = $('.field--name-field-form');
        $(formModule).find("INPUT[name=page_url]").val(pageURL + "?productName=" + productName);
        $(formModule).find(".offer-field-container").css('display', 'flex');
        $(formModule).find(".js-form-item-your-message-to-us").css('display', 'block');
        $(formModule).find(".js-form-item-gdpr").css('display', 'inline-block');
        $(formModule).find(".webform-actions").css('display', 'inline-block');
        $(formModule).find(".show-webform-container").css('display', 'block');
        $(formModule).find(".captcha").css('display', 'block');
        $('.show-webform-container .webform-load-form').css('display', 'none');
        $(formModule).find('.webform-button-container').css('display', 'none');
      });
      // Webshop products reactivity ends



      var cataloqueWebform = context.querySelectorAll('.webform-submission-form.webform-submission-catalogue-order-form');
      if(cataloqueWebform !== null && cataloqueWebform[0]) {
        var checkboxes = cataloqueWebform[0].querySelectorAll('fieldset.webform-type-checkboxes input[type=checkbox]');
        var checkboxLength = checkboxes.length;
        var firstCheckbox = checkboxLength > 0 ? checkboxes[0] : null;

        var init = function() {
          if (firstCheckbox) {
            for (var i = 0; i < checkboxLength; i++) {
              checkboxes[i].addEventListener('change', checkValidity);
            }

            checkValidity(true);
          }
        }

        var isChecked = function() {
          for (var i = 0; i < checkboxLength; i++) {
              if (checkboxes[i].checked) return true;
          }

          return false;
        }

        var checkValidity = function(init) {
          init = init || false;
          var errorMessage = !isChecked() ? 'At least one checkbox must be selected.' : '';
          firstCheckbox.setCustomValidity(errorMessage);
          if (init !== true){
            firstCheckbox.reportValidity();
          }
        }

        init();
      }

      /*
       * Scroll To position big pipe fallback
       */
      if( window.location.hash && context.parentNode !== null ) {
        try {
          var element = context.parentNode.querySelector( window.location.hash );
          if( element !== null ){
            window.scrollTo(
              0,
              $(element).offset().top - 40
            );
          }
        } catch( e ){
        }
      }

      Drupal.treston.menuActions.start(context);

      var as = debounce(function (item) {
        var webform = document.getElementById('block-webform');
        var wH = windowHeight();
        var rect = webform.getBoundingClientRect();
        var top = rect.y,
            bottom = top + rect.height;
        if( (top > 0 && top < wH / 2) || (bottom < 0 && bottom > (wH / 2 * -1)) ){
          window.removeEventListener('scroll', as);
          webform.classList.add('loadImage');
        }
      },100);

      context.querySelectorAll('#block-webform:not(.loadImage)').forEach( function(item) {
        var rect = item.getBoundingClientRect();
        var time = null;
        window.addEventListener('scroll', as);
      });

      var secondary_menu_elems = context.querySelectorAll('.block-superfishmain .block-superfishsecondary-menu-en li');
      if( secondary_menu_elems !== null ){
        $(secondary_menu_elems).unbind();
      }

      // Masonry for customer stories
      var customerStoryView = context.querySelector('.block-system-main-block .view-id-customers.view-display-id-page_1');
      if( customerStoryView !== null ) {
        var $grid = $( customerStoryView.querySelector('.view-content') );
        customerStoryView.querySelectorAll('.view-content img ').forEach( function(item) {
          item.classList.remove('lazyload');
          item.src = item.dataset.src;
        });
        $grid.imagesLoaded().progress( function() {
          $grid.masonry({
            itemSelector: '.views-row',
            columnWidth: '.views-row',
            gutter: '.gutter-sizer',
            percentPosition: true
          });
        });
      }


      // Language switcher
      $(context).findThing('#block-languageswitcher','.dropdown .icon').once('activate-languageswitcher').each(function( i, list ){
        if(!$("BODY").hasClass("user-logged-in")) {
          $("#block-languageswitcher LI.pl").remove();
        } 
        list.addEventListener('click',function(e){
          e.target.nextElementSibling.classList.toggle('open');
        });
      });

      // New language switcher
      $(context).findThing('#block-treston-trestonlanguageselector','#treston-lang-select .icon').once('activate-newlanguageswitcher').each(function( i, list ){
        list.addEventListener('click',function(e){
          e.target.nextElementSibling.classList.toggle('open');
        });
      });


      context.querySelectorAll('.jBox-content').forEach( function(jBoxContent) {
        jBoxContent.style.marginRight = -(jBoxContent.offsetWidth - jBoxContent.clientWidth) + "px";
      });

      $('.add-quantity:not(.appl),.decrease-quantity:not(.appl)',context).each(function( x, button ){
        button.addEventListener('click',function(e){
          var input = $(this).parent().find('.quantity')[0];
          if( this.className.indexOf('add-quantity') != -1 ){
            input.value++;
          }else{
            input.value--;
          }
          input.value = input.value<1?1:(input.value>99?99:input.value);
        });
        button.className += ' appl';
      });

      var indexedVariations = $('.view-indexed-variations',context);

      if( indexedVariations.length == 0 && typeof context.className != 'undefined' && context.className.indexOf('view-indexed-variations') > -1 ){
        indexedVariations = $(context);
      }

      if( typeof indexedVariations != 'undefined' && indexedVariations.length ){

        for( var i = 0; i < indexedVariations.length; i++ ){
          $( indexedVariations[i].getElementsByClassName('display-all') ).each( function(x, link){
            link.addEventListener('click', function(e){
              e.preventDefault();
              $(this).toggleClass('open');
              $("tr.outofsight",this.parentElement).each(function(rowi, row){
                $(row).toggle();
              });
            });
          });

          if( windowWidth() < drupalSettings.breakpoints["treston.large"] ){
            $('.views-field-field-product-image', indexedVariations[i].getElementsByTagName('tbody') ).each(function( x, row ){
              $(row).on('click.mobile',function(e){
                $(row).parent().toggleClass('open')
              });
            });
          }

          // Downloads menu
          $('.views-field-field-downloads .item-list:not(.apl)',indexedVariations[i]).each(function( x, downloads ){
            downloads.addEventListener('click',function(e){
              var $target = $(e.target);
              $target.closest('tbody').find('.item-list.open').each(function( y, oldLinks ){
                $(oldLinks).removeClass('open').find('ol').slideToggle();
              });
              $target.toggleClass('open').find('ol').slideToggle();
            });
            downloads.className += ' apl';
          });
        }
      }

    }
  };





  // Save utm parameters to cookies
  if(typeof URLSearchParams === 'function') {
    var urlParams = new URLSearchParams(location.search);
    if(urlParams.get('utm_term') != null) {
      var keys = ['utm_term', 'utm_campaign', 'utm_content', 'utm_source', 'utm_medium'];
      keys.forEach(function(key){ 
        var value = urlParams.get(key);
        value = (value == null) ? '' : value;
        document.cookie = key + '=' + encodeURIComponent(value) + ';expires=; path=/';
      });

      var url = location.protocol + '//' + location.host + location.pathname;
      document.cookie = 'utm_url=' + encodeURIComponent(url) + ';expires=; path=/';
    }
  }

  // Set 3D link utm parameters
  var threedeeLink = $('#block-3dlink').find('a');
  if(threedeeLink.length > 0) {
    var cookies = [];
    var utmParameters = ['utm_term', 'utm_campaign', 'utm_content', 'utm_source', 'utm_medium', 'utm_url'];
    utmParameters.forEach(function(utmParameter) {
      var cookie = getCookie(utmParameter);
      if(cookie != '') {
        cookies.push(utmParameter+'='+encodeURIComponent(cookie));
      }
    });

    if(cookies.length > 0) {
      var href = threedeeLink.attr('href');
      href += (href.indexOf('?') < 0) ? '?' : '&';
      href += cookies.join('&');
      threedeeLink.attr('href', href);
    }
  }


  Drupal.behaviors.videos_collection_page = {
    attach: function (context, settings) {

      // Modify the URL when a category is selected
      $("#block-views-block-videos-collection-page-block #views-exposed-form-videos-collection-page-block").find("LABEL").on("click", function(e) {
        var target = $(e.target);
        var newPath = window.location.pathname + "?cat=" + $("#" + target.attr("for")).attr("value");
        window.history.pushState({}, '', newPath);
      });



      $('.jbox-video-item', context).once('jbox-video-item').each(function() {
        var $content = $('#'+$(this).data('jbox-content-id')).val();

        $(this).click(function() {
          if($content.length > 0) {
            new jBox('Modal', {
              maxWidth: 1320,
              responsiveWidth: "true",
              width: "80%",
              imageSize: "contain",
              src: "href",
              closeButton: "box",
              content: $content,
              closeOnEsc: true,
              closeOnClick: true,
              onClose: function() {
                $('.jBox-wrapper,.jBox-overlay').remove();
              }
            }).open();
          }
          console.log(".");
          if (window.cookiehub.hasConsented("marketing")) {
            var video = $(".jBox-Modal .iframe-placeholder.disabled-video");
            console.log(video.length);
            if(video.length){
              video.removeClass('disabled-video');
              video.find('iframe').attr("src", video.find('iframe').attr('data-src'));            
            }
          }
        });
      });
    }
  }


})(jQuery, Drupal, drupalSettings);
